import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#04192f] py-8 text-center text-white">
      <p>
       Copyright © 2023 PhurisKR. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;




